export default __webpack_public_path__ + "static/image163-d06c5e52518a61014c6a5ff622ac7837.jpg";